<template>
	<div>
		<!--limit:最大上传数，on-exceed：超过最大上传数量时的操作  on-change:上传成功和失败都会执行-->
		<el-upload
		    class="upload-demo"
		    action=""
		    :on-change="handleChange"
		    :on-remove="handleRemove"
		    :on-exceed="handleExceed"
		    :limit="limitUpload"
		    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
		    :auto-upload="false">
		<!-- <el-button size="small" type="primary" style="float:right;">选取文件</el-button> -->
        <el-button slot="trigger" type="primary" size="small" style="margin-left: 40px;" >选取文件</el-button>
        <el-button type="success" style="margin-left: 60px;" size="small" @click="submitUpload">确认导入</el-button>
		<div slot="tip" class="el-upload__tip" style="margin-left: 40px;color:red;">只 能 上 传 xlsx / xls 文 件</div>
		</el-upload>            
        
		<!-- 数据展示 -->
		  <el-main>
		  <el-table :data="fileData">
		  <div v-if="id==1">
		  <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="sex" label="性别"></el-table-column>
          <el-table-column prop="birthday" label="出生日期"></el-table-column>
          <el-table-column prop="idNum" label="身份证号码"></el-table-column>
          <!--<el-table-column prop="tel" label="联系电话"></el-table-column>-->
          <el-table-column prop="operater" label="录入员"></el-table-column> 
          <el-table-column prop="vip" label="会员编号"></el-table-column>
          <el-table-column prop="group" label="会员类别"></el-table-column>
          <el-table-column prop="district" label="地市"></el-table-column>
		  </div>
          <div v-if="id==2">
          <el-table-column prop="iNum" label="身份证号码"></el-table-column>
          <el-table-column prop="cNum" label="中国跆协证书编号"></el-table-column>
          <el-table-column prop="xNum" label="广西跆协证书编号"></el-table-column>
          <el-table-column prop="type" label="证书类别"></el-table-column>
          <el-table-column prop="level" label="证书等级"></el-table-column>
          <el-table-column prop="start" label="开始日期"></el-table-column>
          <el-table-column prop="end" label="结束日期"></el-table-column>
          <el-table-column prop="operater" label="录入员"></el-table-column>
           <el-table-column prop="status" label="证书状态"></el-table-column>
          </div>
          <div v-if="id==3">
          <el-table-column prop="operater" label="录入员"></el-table-column>
          <el-table-column prop="tel" label="联系电话"></el-table-column>
          <el-table-column prop="cNum" label="团体会员编号"></el-table-column>
          <el-table-column prop="end" label="到期时间"></el-table-column>
          <el-table-column prop="district" label="所属地区"></el-table-column>
          <el-table-column prop="name" label="单位名称"></el-table-column>
          <el-table-column prop="ownerName" label="负责人"></el-table-column>
          <el-table-column prop="address" label="地址"></el-table-column>
          <el-table-column prop="start" label="通过时间"></el-table-column>
          </div>
		 
		 
		  </el-table>
		  </el-main>
	</div>
</template>

<script>
	export default{
		data(){
			return{
			    id:0,
				limitUpload:1,
				fileTemp:null,
				file:null,
				fileData:[],
				fileDataLen:0
			};
		},
		methods:{
			// 添加文件和上传成功和失败都会执行该文件
			handleChange(file, fileList){ 
				console.log("handleChangec参数：",file);
			    this.fileTemp = file.raw; //获取上传文件的头部的信息
			    if(this.fileTemp){ //判断头部是不是为空
			        if((this.fileTemp.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') 
			            || (this.fileTemp.type == 'application/vnd.ms-excel')){ //判断头部是否符合设置
			            this.importfxx(this.fileTemp); //调用文件上传方法
			        } else { //文件格式不对时，提示信息
			            this.$message({
			                type:'warning',
			                message:'附件格式错误，请删除后重新上传！'
			            })
			        }
			    } else { //文件头部是空
			        this.$message({
			            type:'warning',
			            message:'请上传附件！'
			        })
			    }
			},
			//超出文件最大的数量，有关参数limitUpload
			handleExceed(){
			    this.$message({
			        type:'warning',
			        message:'超出最大上传文件数量的限制！'
			    })
			    return;
            },
            submitUpload(){
            var nowD = new Date()
            var endD = new Date('2022/02/01 12:00:00')
          //if( nowD.getTime() < endD.getTime()){ 
            let postUrl='',redirect
            if(this.id==1){
             postUrl='/teacher/addMass' 
             redirect='/home/teacher'
            }
            if(this.id==2){
             postUrl='/course/addMass'  
             redirect='/home/course'
            }
            if(this.id==3){
             postUrl='/place/addMass' 
             redirect='/home/place'
            }
            this.axios.post(postUrl,{data:this.fileData})
            .then(res=>{
                console.log(res.data)
                if(res.data.code=='200'){
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                    this.$router.push({path:redirect});
                
                }else{
                 this.$message.error(res.data.msg);   
                }
            })
            .catch(err=>{
                console.log(err)
                 this.$message.error(err);
            })
          //}   
			},
			//文件移除时的钩子
			handleRemove(file,fileList){
			    this.fileTemp = null
			},
            	// 格式化数字
			PrefixInteger(num, n) {
			return (Array(n).join(0) + num).slice(-n);
			},
			switchTimeFormat(time) {
			const dateTime = new Date(time);
			const year = dateTime.getFullYear();
			const month = dateTime.getMonth() + 1;
			const date = dateTime.getDate();
			return `${year}-${this.PrefixInteger(month,2)}-${this.PrefixInteger(date,2)}`;
			},

		
             
			//文件上传方法
			importfxx(obj) {
			    let _this = this; //声明一个变量指向Vue实例this，保证作用域一致,_this只是一个变量名，this代表父函数，如果在子函数还用this，this的指向就变成子函数了，_this就是用来存储指向的。
				let inputDOM = this.$refs.inputer; //通过ref绑定的组件，直接访问demo，减少消耗。
			    // 通过DOM取文件数据
			    this.file = event.currentTarget.files[0];
				
			    var rABS = false; //是否将文件读取为二进制字符串
			    var f = this.file; //将父类的file，赋值给f
			
			    var reader = new FileReader();
			    FileReader.prototype.readAsBinaryString = function(f) {
			        var binary = "";
			        var rABS = false; //是否将文件读取为二进制字符串
			        var pt = this;
			        var wb; //读取完成,转换后数据
			        var outdata;//用来存储原始数据
			        var reader = new FileReader();
					//读取文件readAsBinaryString，会触发一个load时间，使用reader.onload对该事件进行处理
			        reader.onload = function(e) {
						//reader.result:返回文件的内容,只有读取操作后，该属性才能生效
			            var bytes = new Uint8Array(reader.result); // Uint8Array: 8位无符号整数，长度1个字节
			            var length = bytes.byteLength;
			            for (var i = 0; i < length; i++) {
			                binary += String.fromCharCode(bytes[i]); //返回由指定的 UTF-16 代码单元序列创建的字符串
			            }
			            var XLSX = require("xlsx");
			            if (rABS) {
			                wb = XLSX.read(btoa(fixdata(binary)), {
			                //手动转化
			                type: "base64"
			                });
			            } else {
			                wb = XLSX.read(binary, {
			                type: "binary",
			                cellDates: true//设为true，将天数的时间戳转为时间格式
			                });
			            }
			            outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); //outdata就是你想要的东西
			            console.log('未处理的原始数据如下：');
			            console.log(outdata);
			            //此处可对数据进行处理
			            let arr = [];
						// outdata.map将outdata中的数据循环并且放置在arr中进行输出
							if(_this.id==1){
			            outdata.map(v => {
			                let obj = {}
                            obj.name = v['姓名']
                            obj.sex = v['性别']
                            obj.birthday =_this.switchTimeFormat(v['出生日期'])
                            obj.img = "/images/avator.jpg"
							obj.idNum =v['身份证号码']
							obj.tel ='1'
							obj.operater = v['录入员']
							obj.vip = v['会员编号']
							obj.group = v['会员类别']
							obj.district =v['地市']
                           
			                arr.push(obj)
			            });
						}
						if(_this.id==2){
			            outdata.map(v => {
			                let obj = {}
			                // obj.no = v['序号']
			                obj.iNum = v['身份证号码']
                            obj.cNum = v['中国跆协证书编号']
                            obj.xNum = v['广西跆协证书编号']
                            obj.type = v['证书类别']
                            obj.level = v['证书等级']
                            obj.start =_this.switchTimeFormat(v['开始日期'])
							obj.end =v['结束日期']?_this.switchTimeFormat(v['结束日期']):''
                            obj.operater = v['录入员']
                            obj.status = v['证书状态']
         
                           
			                arr.push(obj)
			            });
						}
							if(_this.id==3){
			            outdata.map(v => {
			                let obj = {}
			                obj.img ="/images/avator.jpg"
			                obj.operater = v['录入员']
			                obj.tel = v['联系电话']
                            obj.cNum = v['团体会员编号']
							obj.end =_this.switchTimeFormat(v['截止日期'])
							obj.district =v['地市']
							obj.name =v['单位名称']
							obj.ownerName =v['负责人']
							obj.address =v['地址']
							obj.start =_this.switchTimeFormat(v['开始日期'])
			                arr.push(obj)
			            });
						}
                        _this.fileData=arr;
                        console.log(_this.fileData)
			            _this.fileDataLen=arr.length;
			            return arr;
			        };
			        reader.readAsArrayBuffer(f);
			    };
			    if (rABS) {
			        reader.readAsArrayBuffer(f);
			    } else {
			        reader.readAsBinaryString(f);
			    }
			}

		
			
			
		},
		
		created(){
           
            this.id=this.$route.params.id
            console.log(this.id);
		}
		
		
	}
</script>


<style>
</style>